// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#loader-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 15;
}

.loader {
  width: 150px;
  height: 150px;
  border: 5px #fff solid;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
}

.loader .loading {
  font-size: 10px;
  position: absolute;
  width: 100%;
  text-align: center;
  line-height: 14px;
  font-family: "Century Gothic", sans-serif;
  font-style: italic;
  left: 0;
  top: 50%;
  margin-top: 20px;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
}

.loader .line {
  width: 10px;
  height: 2px;
  background: #fff;
  position: absolute;
}

.loader .line:nth-child(1) {
  left: 16px;
  top: 50%;
  margin-top: -1px;
}

.loader .line:nth-child(2) {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  left: 33px;
  top: 33px;
}

.loader .line:nth-child(3) {
  top: 16px;
  left: 50%;
  width: 2px;
  height: 10px;
}

.loader .line:nth-child(4) {
  transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  right: 33px;
  top: 33px;
}

.loader .line:nth-child(5) {
  right: 16px;
  top: 50%;
  margin-top: -1px;
}

.loader .line:nth-child(6) {
  transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  right: 33px;
  bottom: 33px;
  background: #ffffff;
}

.loader .subline {
  position: absolute;
  width: 3px;
  height: 2px;
  background: #fff;
}

.loader .subline:nth-child(7) {
  transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -webkit-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  left: 21px;
  top: 50px;
}

.loader .subline:nth-child(8) {
  transform: rotate(67.5deg);
  -moz-transform: rotate(67.5deg);
  -webkit-transform: rotate(67.5deg);
  -ms-transform: rotate(67.5deg);
  left: 50px;
  top: 21px;
}

.loader .subline:nth-child(9) {
  transform: rotate(112.5deg);
  -moz-transform: rotate(112.5deg);
  -webkit-transform: rotate(112.5deg);
  -ms-transform: rotate(112.5deg);
  right: 50px;
  top: 21px;
}

.loader .subline:nth-child(10) {
  transform: rotate(157.5deg);
  -moz-transform: rotate(157.5deg);
  -webkit-transform: rotate(157.5deg);
  -ms-transform: rotate(157.5deg);
  right: 21px;
  top: 50px;
}

.loader .subline:nth-child(11) {
  transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -webkit-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  right: 20px;
  bottom: 49px;
  background: #ffffff;
}

.loader .needle {
  width: 14px;
  height: 14px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -8px 0 0 -8px;
  z-index: 1;
  animation: pegIt 3s infinite ease-in-out;
}

.loader .needle:before {
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 3.5px 50px 3.5px 0;
  border-color: transparent #ffffff transparent transparent;
  position: absolute;
  right: 50%;
  top: 50%;
  margin: -3.5px 0 0 0;
  border-radius: 0 50% 50% 0;
}

@keyframes pegIt {
  0% {
    transform: rotate(0deg);
  }
  16% {
    transform: rotate(75deg);
  }
  25% {
    transform: rotate(55deg);
  }
  30% {
    transform: rotate(90deg);
  }
  36% {
    transform: rotate(170deg);
  }
  42% {
    transform: rotate(150deg);
  }
  50% {
    transform: rotate(227deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,WAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,2BAAA;EACA,gCAAA;EACA,mCAAA;EACA,+BAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,2BAAA;EACA,gCAAA;EACA,mCAAA;EACA,+BAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,0BAAA;EACA,+BAAA;EACA,kCAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EAEA,wCAAA;AACF;;AAEA;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,yDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,oBAAA;EACA,0BAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EACA;IACE,wBAAA;EACF;EACA;IACE,wBAAA;EACF;EACA;IACE,wBAAA;EACF;EACA;IACE,yBAAA;EACF;EACA;IACE,yBAAA;EACF;EACA;IACE,yBAAA;EACF;EACA;IACE,uBAAA;EACF;AACF;AAsCA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF","sourcesContent":["#loader-wrapper {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 15;\n}\n\n.loader {\n  width: 150px;\n  height: 150px;\n  border: 5px #fff solid;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -75px 0 0 -75px;\n  border-radius: 50%;\n}\n\n.loader .loading {\n  font-size: 10px;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  line-height: 14px;\n  font-family: 'Century Gothic', sans-serif;\n  font-style: italic;\n  left: 0;\n  top: 50%;\n  margin-top: 20px;\n  color: #fff;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.loader .line {\n  width: 10px;\n  height: 2px;\n  background: #fff;\n  position: absolute;\n}\n\n.loader .line:nth-child(1) {\n  left: 16px;\n  top: 50%;\n  margin-top: -1px;\n}\n\n.loader .line:nth-child(2) {\n  transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  left: 33px;\n  top: 33px;\n}\n\n.loader .line:nth-child(3) {\n  top: 16px;\n  left: 50%;\n  width: 2px;\n  height: 10px;\n}\n\n.loader .line:nth-child(4) {\n  transform: rotate(135deg);\n  -moz-transform: rotate(135deg);\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  right: 33px;\n  top: 33px;\n}\n\n.loader .line:nth-child(5) {\n  right: 16px;\n  top: 50%;\n  margin-top: -1px;\n}\n\n.loader .line:nth-child(6) {\n  transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  right: 33px;\n  bottom: 33px;\n  background: #ffffff;\n}\n\n.loader .subline {\n  position: absolute;\n  width: 3px;\n  height: 2px;\n  background: #fff;\n}\n\n.loader .subline:nth-child(7) {\n  transform: rotate(22.5deg);\n  -moz-transform: rotate(22.5deg);\n  -webkit-transform: rotate(22.5deg);\n  -ms-transform: rotate(22.5deg);\n  left: 21px;\n  top: 50px;\n}\n\n.loader .subline:nth-child(8) {\n  transform: rotate(67.5deg);\n  -moz-transform: rotate(67.5deg);\n  -webkit-transform: rotate(67.5deg);\n  -ms-transform: rotate(67.5deg);\n  left: 50px;\n  top: 21px;\n}\n\n.loader .subline:nth-child(9) {\n  transform: rotate(112.5deg);\n  -moz-transform: rotate(112.5deg);\n  -webkit-transform: rotate(112.5deg);\n  -ms-transform: rotate(112.5deg);\n  right: 50px;\n  top: 21px;\n}\n\n.loader .subline:nth-child(10) {\n  transform: rotate(157.5deg);\n  -moz-transform: rotate(157.5deg);\n  -webkit-transform: rotate(157.5deg);\n  -ms-transform: rotate(157.5deg);\n  right: 21px;\n  top: 50px;\n}\n\n.loader .subline:nth-child(11) {\n  transform: rotate(22.5deg);\n  -moz-transform: rotate(22.5deg);\n  -webkit-transform: rotate(22.5deg);\n  -ms-transform: rotate(22.5deg);\n  right: 20px;\n  bottom: 49px;\n  background: #ffffff;\n}\n\n.loader .needle {\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -8px 0 0 -8px;\n  z-index: 1;\n  -webkit-animation: pegIt 3s infinite ease-in-out;\n  animation: pegIt 3s infinite ease-in-out;\n}\n\n.loader .needle:before {\n  content: '';\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 3.5px 50px 3.5px 0;\n  border-color: transparent #ffffff transparent transparent;\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  margin: -3.5px 0 0 0;\n  border-radius: 0 50% 50% 0;\n}\n\n@keyframes pegIt {\n  0% {\n    transform: rotate(0deg);\n  }\n  16% {\n    transform: rotate(75deg);\n  }\n  25% {\n    transform: rotate(55deg);\n  }\n  30% {\n    transform: rotate(90deg);\n  }\n  36% {\n    transform: rotate(170deg);\n  }\n  42% {\n    transform: rotate(150deg);\n  }\n  50% {\n    transform: rotate(227deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@-webkit-keyframes pegIt {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  16% {\n    -webkit-transform: rotate(75deg);\n  }\n  25% {\n    -webkit-transform: rotate(55deg);\n  }\n  30% {\n    -webkit-transform: rotate(90deg);\n  }\n  36% {\n    -webkit-transform: rotate(170deg);\n  }\n  42% {\n    -webkit-transform: rotate(150deg);\n  }\n  50% {\n    -webkit-transform: rotate(227deg);\n  }\n  100% {\n    -webkit-transform: rotate(0deg);\n  }\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
